import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStarStroke = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.88477 1.12978L10.6712 4.74949C10.8169 5.04464 11.0984 5.24921 11.4241 5.29654L15.4187 5.87698L12.5282 8.69454C12.2925 8.92428 12.185 9.25528 12.2406 9.57967L12.923 13.5581L9.35011 11.6798C9.05878 11.5266 8.71075 11.5266 8.41942 11.6798L4.84655 13.5581L5.52891 9.57967C5.58455 9.25528 5.477 8.92428 5.24131 8.69454L2.35079 5.87698L6.34539 5.29654C6.6711 5.24921 6.95267 5.04464 7.09833 4.74949L8.88477 1.12978Z",
		stroke: "black"
	})
});
export default SvgStarStroke;
